import type { RefObject } from 'react';
import type { TFunction } from 'react-i18next';
import type { GuardBusy } from 'ts-components/PiChat/PiChatPanel';
import { claimKiCodeSurface, panelSurfaceGuard } from '../activeSurface';

export const KICODE_SURFACE_ID = 'kicode-global';

export interface KiCodeSessionSurface {
  /**
   * Claims while the resume lookup is pending too, so another surface opening
   * evicts this panel; the release never clears a later surface's claim.
   */
  mount: () => () => void;
  /** Claims nothing: a surface opened during the lookup keeps the surface. */
  chatMounted: () => void;
}

/** `panel` is empty while the pending panel shows: no confirmation needed. */
export const kiCodeSessionSurface = (
  onClose: () => void,
  panel: RefObject<GuardBusy>,
  t: TFunction
): KiCodeSessionSurface => ({
  mount: () =>
    claimKiCodeSurface(KICODE_SURFACE_ID, onClose, panelSurfaceGuard(panel, t)),
  chatMounted: () => {},
});
